import React, { useEffect, useState } from 'react';
import '../App.css';
import Layout from '../components/Layout';

const SmartManagement = () => {
  const [activeSection, setActiveSection] = useState(0);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const contentSections = [
    {
      title: '教务管理系统',
      content: '校园教务管理系统是面向中职院校教务处、教师、学生等多层次用户的一体化教务信息管理平台。该平台涵盖了教务工作的基础管理、课程安排管理、考务管理、教学评价、教师发展及教研管理、学生学籍管理等多个子产品，且基于不同模块数据的一体化集成与对接，提供智能选课/排课、一键排考、成绩管理等多种功能，实现了从教学开始前的教学计划、课程/环节制定，到教学过程中的考务、成绩管理，再到教学结束后的教学评价等全流程管理。通过构建完善的教务管理保障体系，实现了教务管理数字化、一体化，具有专业、实用及高效管理教务工作的特点。',
      img: <img src="/src/img/jwgl.png" alt="" />
    },
    {
      title: '学工管理系统',
      content: '学生信息的集中管理和共享，包括学生基本信息、成绩、课程表、奖助贷等，方便学校各部门之间的信息共享和协作，提高学生管理效率。支持提供在线服务功能，如成绩查询、奖助贷申请等，方便学生自主办理相关业务，减少学生排队等待的时间，提升服务质量和学生满意度。',
      img: <img src="/src/img/xggl.png" alt="" />
    },
    {
      title: '离校管理系统',
      content: '该系统提供离校流程管理服务，管理员能够灵活设置离校时间、离校说明及上传离校流程单、配置各流程关键信息，同时支持学生离校审核和状态管理，学生可通过该模块上传离校流程单和了解离校进度，有助于学校更有效地跟踪和管理离校情况，为学生提供更便捷和透明的离校服务。',
      img: <img src="/src/img/lxgl.png" alt="" />
    },
    {
      title: '迎新管理系统',
      content: '支持本地导入和在线同步新生名单，能够根据学校的分配规则，自动分配班级及学号。同时系统采用自定义管理的方式为管理员提供了新生报到管理、绿色通道与暂缓入学审核、信息采集等服务，支持新生一卡通和宿舍入住等管理，满足了学校灵活管理以及个性化应用的需求。系统提供迎新数据看板服务，能够实时展示迎新工作进度、迎新动态和新生的报到情况，为学校提供了全面的数据分析和决策支持；同时，系统还支持迎新活动、迎新问答、迎新资讯、迎新公告发布等系列管理功能，为学校提供了丰富多彩的迎新活动和资讯服务，增强了新生的归属感和满意度。',
      img: <img src="/src/img/yxgl.png" alt="" />
    },
    {
      title: '宿舍管理系统',
      content: '宿舍管理系统包含了公寓楼栋管理、楼层管理、宿舍管理、宿舍设备管理、宿舍分配、宿舍调宿管理、查寝管理、卫生检查、住宿缴费等业务功能。其中学生可在维修系统中提交日常宿舍损坏信息，保修登记，后勤管理系统中可对来访宿舍进行登记，系统与系统之间无缝对接。可以实时掌握学校的公寓楼使用情况、每层房间使用情况、整个学校学生住宿情况、每个学生的住宿情况等。整个系统可无缝对接迎新管理系统，可提供学校迎新前可给学生进行提前分配宿舍，学生在手机端，服务大厅，招生网可提前知道预分配宿舍情况。系统还可无缝对接收费系统，收费管理系统可收取不同宿舍费用，统一数据管理中心可无缝对接宿舍管理系统，无需再宿舍中在添加用户添加学生方便简洁使用系统。可以单独使用宿舍管理系统。',
      img: <img src="/src/img/ssgl.png" alt="" />
    },
    {
      title: '资产管理系统',
      content: '资产管理系统，通过对数据的采集、汇总，系统从资产总览、资产消耗、资产采购、资产使用和资产维修五个维度进行了智能的数据可视化展示，其中资产使用包括领用、借用两部分。管理员可根据时间筛选条件查看指定日期范围内各维度的资产情况。同时可自动汇总设备资产数据并形成可视化数据图表，实现资产管理数字化、精细化。通过数据的可视化展示，管理员可以更加直观地查看资产的状态，为管理层对资产的管理、决策起到支撑作用。',
      img: <img src="/src/img/zcgl.png" alt="" />
    },
    {
      title: '财务管理系统',
      content: '学校各项经济业务的记录和分类核算。协助学校进行预算编制、预算分配、预算执行监控和分析，以确保学校资金的合理安排和有效使用。对学校的资金收支进行管理，如学费收取、费用报销、资金划拨等，同时监控资金流动情况。管理学校的固定资产、无形资产等资产的增加、减少、折旧计提等，确保资产的安全和完整。处理教职工工资的核算、发放和统计，包括工资条生成等。针对学费、住宿费等各种收费项目进行设置、计费、统计和查询。自动生成资产负债表、利润表、现金流量表等各种财务报表，满足学校内部管理和外部报告的需求。',
      img: <img src="/src/img/cwgl.png" alt="" />
    },
    {
      title: '人事管理系统',
      content: '人事管理系统以学校教职工档案管理为基础，构建了支持灵活拓展的多维度教职工档案数据体系，实现了对校园各类人事业务的高度集成化管理。系统全面覆盖校园教职工组织机构、人员档案、人事异动、薪酬、社保、合同、绩效、培训等重要环节，并通过对考勤、教务、师资发展等平台的人事信息数据的整合以及管理协同，实现对招聘、入职、培训、考核、薪资、离职和退休全过程跟踪和管理，初步形成教职工数字化档案资源动态全景，为学校人员配置优化提供更精准的支撑，促进科学用档、有效用档。',
      img: <img src="/src/img/rsgl.png" alt="" />
    },
    {
      title: '科研管理系统',
      content: '科研管理系统由科研门户、科研流程、科研项目、科研组织、科研经费、协同研发、成果与标准体系、科研知识、科研决策等八大体系构成，可应用于高校科研部门，帮助学校科研部门实现了科研管理标准化、合规化、智能化的目标。科研管理系统支持根据不同的项目岗位，提供个性化的岗位工作桌面，将岗位所需要的科研相关的信息、数据和应用功能进行实时的推送。不同岗位的科研项目人员提供不同的项目工作看板，覆盖从科研领导到员工，根据不同的层面提供其关心的内容，提高科研工作效率。',
      img: <img src="" alt="" />
    },
    {
      title: '智就业管理系统',
      content: '智就业管理系统采用大数据挖掘技术，构建“企业精准招聘，学生精准就业，学校精准教育”的服务体系，根据模型为学生综合推荐企业和岗位，实现精准的就业，结合学生画像，对岗位进行精准的岗位竞争力分析，如岗位的匹配度、群体中有多少人适合该岗位、专业中多少人适合。通过打通全校数据，汇总毕业生校内全生涯数据，通过数据交换及治理，生成毕业生智能简历，并可提供多类型模板的选择。',
      img: <img src="/src/img/zjygl.png" alt="" />
    }
  ];

  const handleSectionChange = (index) => {
    setActiveSection(index);
  };

  return (
    <Layout>
      <div className="page-header" style={{ 
        backgroundImage: 'url("/src/img/zhmkt.png")',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        height: '300px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: '20px'
      }}>
        <h1 style={{ 
          color: '#fff',
          fontSize: '2.5rem',
          fontWeight: 'bold',
          textShadow: '2px 2px 4px rgba(0,0,0,0.5)'
        }}>智慧管理系统</h1>
      </div>
      <div className="page-container">
        <div className="page-layout">
          <div className="left-menu">
            {contentSections.map((section, index) => (
              <div
                key={index}
                className={`menu-item ${activeSection === index ? 'active' : ''}`}
                onClick={() => handleSectionChange(index)}
              >
                {section.title}
              </div>
            ))}
          </div>
          <div className="content-section">
            <div className="section-header" style={{
              padding: '20px 40px',
              marginBottom: '30px'
            }}>
              <h3 style={{
                fontSize: '1.2rem',
                lineHeight: '1.6',
                color: '#333',
                textIndent: '2em'
              }}>{contentSections[activeSection].content}</h3>
            </div>
            <div className="management-content">
              <div className="management-features" style={{ display: 'flex', justifyContent: 'center', height: '500px', marginBottom: '40px' }}>
                <div style={{ width: '1000px', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', overflow: 'hidden' }}>
                  {contentSections[activeSection].img && React.cloneElement(contentSections[activeSection].img, {
                    style: { width: '100%', height: '100%', objectFit: 'contain' }
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default SmartManagement;